<template>
<div class="container-fluid">
	<img v-if="!data_loaded" class="center-me" src="/images/loading-color.svg">

	<template v-if="perms.can_administer_clients">

		<div class="row">
		    <div class="col">
				<h1 data-test="pageTitle">Create Client</h1>
			</div>
		</div>

		<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)" class="mb-0">
			<alert-errors :form="form">There were some problems with your input.</alert-errors>
			<div class="row">		
			    <div class="col-12">
				    <div class="card">
					    <div class="card-header">Basic Info</div>
						<div class="card-body row">
							<div class="col-md-auto">
								<label class="mb-0">Client Logo</label>
								<file-field
									ref="logo"
									@file_changed="changedLogo($event)"
								/>
						    </div>

							<div class="col">
							    <div class="form-group">
							    	<label class="mb-0">Client Name</label>
							    	<input class="form-control" v-model="form.name" required data-test="clientName">
							    </div>

							    <div class="form-group">
							    	<label class="mb-0">Status</label>
			                        <v-select        
			                            :options="[
			                            	{ label:'Active', value:1 },
			                            	{ label:'Inactive', value:0 }
			                            ]"
			                            :reduce="label => label.value"
			                            v-model="form.status"
			                            data-test="clientStatus"
			                        />
							    </div>

							    <div class="form-group">
							    	<label class="mb-0">Theme / White Label</label>
			                        <v-select        
			                            :options="[
			                            	{ label:'Default / None', value:null },
			                            	{ label:'FlightPlan', value:'flightplan' }
			                            ]"
			                            :reduce="label => label.value"
			                            v-model="form.theme"
			                        />
							    </div>

							    <div class="form-group">
								    <label class="mb-0">Service Lines</label>
			                        <v-select
			                            multiple
			                            label="label"
			                            :options="options.service_lines"
			                            :reduce="label => label.id"
			                            v-model="form.service_lines"
			                            data-test="clientServiceLines"
			                        />
							    </div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-6">
				    <div class="card">
					    <div class="card-header">Location</div>
					    <div class="card-body row">

							<div class="col-md-auto">
								<label class="mb-0">Facility or Background Image</label>
								<file-field
									ref="photo"
									@file_changed="changedPhoto($event)"
								/>
						    </div>

							<div class="col">
							    <div class="form-group">
							    	<label class="mb-0">Address</label>
							    	<input class="form-control mb-2" v-model="form.address" data-test="clientLocationAddress">					    	
							    	<input class="form-control" v-model="form.address_2" data-test="clientLocationAddress2">	
							    </div>

							    <div class="row">		
								    <div class="form-group col-12">
								    	<label class="mb-0">City</label>
							    		<input class="form-control" v-model="form.city" data-test="clientLocationCity">
								    </div>
								</div>
								<div class="form-row">
								    <div class="form-group col-6">
									    <label class="mb-0">State</label>
					                    <v-select
					                        label="label"
					                        :select-on-key-codes="[9, 13]"
					                        :options="options.states"
					                        :reduce="label => label.id"
					                        v-model="form.state"
					                        data-test="clientLocationState"
					                    />
								    </div>
								    <div class="form-group col-6">
								    	<label class="mb-0">Zip</label>
							    		<input class="form-control" type="number" v-model="form.zip" data-test="clientLocationZip">
								    </div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-6">
				    <div class="card">
					    <div class="card-header">Main Contact</div>
					    <div class="card-body">
					    	<div class="form-row">
							    <div class="col form-group">
									<label class="mb-0">First Name</label>
									<input class="form-control" v-model="form.contact_first_name" data-test="clientContactFirstName">
							    </div>
							    <div class="col form-group">
									<label class="mb-0">Last Name</label>
									<input class="form-control" v-model="form.contact_last_name" data-test="clientContactLastName">
							    </div>
							</div>
						    <div class="form-group">
								<label class="mb-0">Email</label>
								<input class="form-control" type="email" v-model="form.contact_email" data-test="clientContactEmail">
						    </div>
						    <div class="form-row">				    	    
							    <div class="col form-group">
									<label class="mb-0">Phone</label>
									<input class="form-control" type="tel" v-model="form.phone" data-test="clientContactPhone">
							    </div>
							    <div class="col form-group">
									<label class="mb-0">Fax</label>
									<input class="form-control" type="tel" v-model="form.fax" data-test="clientContactFax">
							    </div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12">
					<div class="card">
					    <div class="card-header">Extra Settings</div>
					    <div class="card-body">
						    <div class="form-group">
								<label class="mb-0">EMR Type</label>
		                        <v-select        
		                            :options="[
		                            	{ label:'Luvo EMR', value:'luvo_emr' }
		                            ]"
		                            :reduce="label => label.value"
		                            v-model="form.emr_type"
		                        />
						    </div>
						    <div class="form-group">
								<label class="mb-0">EMR ID</label>
								<input class="form-control" v-model="form.emr_id">
						    </div>
						    <div class="form-group form-check">
								<input type="checkbox" class="form-check-input" v-model="form.import_emr_physicians" :false-value="0" :true-value="1">
								<label class="form-check-label">Import and sync EMR physicians with Ember</label>
						    </div>

						    <div class="form-group">
								<label class="mb-0">Quicksight Username</label>
								<input class="form-control" v-model="form.quicksight_username" data-test="saveQuicksight">
						    </div>
						    <div class="form-group">
								<label class="mb-0">AWS Key</label>
								<input class="form-control" v-model="form.aws_key" data-test="saveAwsKey">
						    </div>
						    <div class="form-group">
								<label class="mb-0">AWS Secret Key</label>
								<input class="form-control" v-model="form.aws_secret_key" data-test="saveAwsSecret">
						    </div>						    					    					    				    	
					    </div>
					</div>
				</div>

				<div class="col-12">
				    <div class="form-group">
				    	<button type="submit" class="btn btn-primary" data-test="saveClientButton">Save Client</button>
					</div>
				</div>

			</div>
		</form>
	</template>
</div>
</template>

<script>
	import { mapState } from 'vuex';
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';
	import { objectToFormData } from 'object-to-formdata'

    export default {

    	mixins: [BreadcrumbsManager],

    	components: {
            HasError,
            AlertError,
            AlertErrors,
            AlertSuccess,
            Form    		
    	},

        data () {
            return {
                client: [],
                data_loaded: true,
                form: new Form({
                    name: null,
                    status: null,
					//logo: null,
					theme: null,
					service_lines: null,
					//photo: null,
					address: null,
					address_2: null,
					city: null,
					state: null,
					zip: null,
					contact_first_name: null,
					contact_last_name: null,
					phone: null,
					fax: null,
					contact_email: null,
					emr_type: null,
					emr_id: null,
					import_emr_physicians: 0,
					quicksight_username: null,
					aws_key: null,
					aws_secret_key: null,
                }),
            }
        },

        created() {
        },

        activated() {
        	this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Clients', to: { name: 'clients.index' } },
                { text: 'Create Client', to: { name: 'clients.create' } },
            ]);  
        },

        methods: {
            changedPhoto($event) {
                this.form.photo = this.$refs.photo.file;
            },

            changedLogo($event) {
                this.form.logo = this.$refs.logo.file;
            },

        	submitForm() { 
            	this.data_loaded = false;

                this.form.submit('post', '/api/admin/clients', {
					transformRequest: [function (data, headers) {
						return objectToFormData(data)
					}],
                }).then(({ data }) => {
					Swal.fire({
						toast: true,
						position: 'top-end',
						showConfirmButton: false,
						timer: 4000,
						icon: 'success',
						title: 'Client created',
					});	
                	this.$router.push({ name: 'clients.show', params: { id: data.id } })
                //stuff
            	});

            	this.data_loaded = true;
        	},
          
        },

        computed: {
        	...mapState(['options', 'perms'])
        },
    }
</script>

<style>
</style>